import React, { useState } from "react";

import { cn } from "../cn";
import { CircleQuestionMark } from "../icons";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui";

export function RedesignQuestionTooltip({
  side = "top",
  className,
  contentClassName,
  testId,
  trigger,
  children,
}: {
  side?: React.ComponentProps<typeof TooltipContent>["side"];
  className?: string;
  contentClassName?: string;
  testId?: string;
  trigger?: React.ReactNode;
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(false);

  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip open={open} onOpenChange={setOpen}>
        <TooltipTrigger
          type="button"
          data-testid={testId}
          onClick={() => setOpen(true)}
          className={cn(
            trigger
              ? "tw-inline-flex tw-cursor-pointer tw-items-center tw-justify-center tw-border-none tw-bg-transparent tw-p-0 tw-text-inherit"
              : "tw-relative tw-top-[-0.09em] tw-ml-1 tw-inline-flex tw-h-[1em] tw-shrink-0 tw-cursor-default tw-items-center tw-justify-center tw-border-none tw-bg-transparent tw-align-middle tw-text-muted-foreground",
            className,
          )}
        >
          {trigger ?? <CircleQuestionMark className="tw-block tw-size-4" aria-hidden />}
        </TooltipTrigger>
        {/* Radix repositions collision content but does not shrink it, so the tooltip needs a viewport cap. */}
        <TooltipContent side={side} data-rd-hint className={cn("tw-max-w-[min(375px,calc(100vw-2rem))]", contentClassName)}>
          {children}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
